module.exports = __webpack_public_path__ + "od-circle-icon/od-circle-icon-1f01157351a9c1202b9f5dcc615aa3aa.svg";